//import router from '../../router'
import { State, ServerResponse, ErrorResponse, ServerBridgesResponse } from '../types/bridge'
import fileDownload from 'js-file-download'

export const state: State = {
  logs: [],
  loading: false,
  reload: false,
  errors: [],
  item: [],
  items: [],
  preparedItem: [],
  bridgeMaintenanceCosts: [],
  bridgeMaintenanceLogs: [],
  bridgePlans: [],
  bridgeDocuments: [],
  bridgePhotos: [],
  bridgeFolderPhotos: [],
  bridgeInspectionReports: [],
  bridgeSpecialItems: [],
  bridgePermitRatings: [],
  msg: "",
}

// getters
const getters = {
  getLogs: function(state: State): Array<string> { return state.logs },
  getLoading: function(state: State): boolean { return state.loading },
  getReload: function(state: State): boolean { return state.reload },
  getErrors: function(state: State): Array<string> { return state.errors },
  getItem: function(state: State): Array<string|number|boolean|Array<object>> { return state.item },
  getItems: function(state: State): Array<string|number|boolean|Array<object>> { return state.items },
  getPreparedItem: function(state: State): Array<string|number|boolean> { return state.preparedItem },
  getBridgeMaintenanceCosts: function(state: State): Array<string|number|boolean> { return state.bridgeMaintenanceCosts },
  getBridgeMaintenanceLogs: function(state: State): Array<string|number|boolean> { return state.bridgeMaintenanceLogs },
  getBridgePlans: function(state: State): Array<string|number|boolean> { return state.bridgePlans },
  getBridgeDocuments: function(state: State): Array<string|number|boolean> { return state.bridgeDocuments },
  getBridgePhotos: function(state: State): Array<string|number|boolean> { return state.bridgePhotos },
  getBridgeFolderPhotos: function(state: State): Array<string|number|boolean> { return state.bridgeFolderPhotos },
  getBridgeInspectionReports: function(state: State): Array<string|number|boolean> { return state.bridgeInspectionReports },
  getBridgePermitRatings: function(state: State): Array<string|number|boolean> { return state.bridgePermitRatings },
  getBridgeSpecialItems: function(state: State): Array<string|number|boolean> { return state.bridgeSpecialItems },
  getMsg: function(state: State): string { return state.msg },
}

// actions
const actions = {
  getBridges: function({commit}: {commit: Function}, payload: object): void {
    commit('setLoading', true)
    commit('setErrors', [])
    axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/getBridges', payload)
        .then(function(response: ServerBridgesResponse) {
          commit('setItems', response.data.bridges)
          commit('setLoading', false)
        })
        .catch(function(error: ErrorResponse) {
          commit('setLoading', false)
          commit('setErrors', error.response.data.errors)
        })
  },
  storeBridge: function({commit}: {commit: Function}, payload: object): void {
    commit('setLoading', true)
    commit('setErrors', [])
    commit('setMsg', "")
    axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/storeBridge', payload)
        .then(function(response: any) {
          commit('setMsg', response.data.msg)
          commit('setReload', true)
          commit('setLoading', false)
        })
        .catch(function(error: ErrorResponse) {
          commit('setLoading', false)
          commit('setErrors', error.response.data.errors)
        })
  },
  deleteBridge: function({commit}: {commit: Function}, payload: object): void {
    commit('setLoading', true)
    commit('setErrors', [])
    commit('setMsg', "")
    axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/deleteBridge', payload)
        .then(function(response: any) {
          commit('setMsg', response.data.msg)
          commit('setReload', true)
          commit('setLoading', false)
        })
        .catch(function(error: ErrorResponse) {
          commit('setLoading', false)
          commit('setErrors', error.response.data.errors)
        })
  },

  getGeneralInfo: function({commit}: {commit: Function}, payload: object): void {
    commit('setLoading', true)
    commit('setErrors', [])
    axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/getGeneralInfo', payload)
        .then(function(response: ServerResponse) {
          commit('setPreparedItem', response.data.preparedItem)
          commit('setLoading', false)
        })
        .catch(function(error: ErrorResponse) {
          commit('setLoading', false)
          commit('setErrors', error.response.data.errors)
        })
  },

  updateGeneralInfo: function({commit}: {commit: Function}, payload: object): void {
    commit('setLoading', true)
    commit('setErrors', [])
    commit('setMsg', "")
    axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/updateGeneralInfo', payload)
        .then(function(response: any) {
          commit('setMsg', response.data.msg)
          commit('setReload', true)
          commit('setLoading', false)
        })
        .catch(function(error: ErrorResponse) {
          commit('setLoading', false)
          commit('setErrors', error.response.data.errors)
        })
  },

  //Maintenance Costs
  getMaintenanceCosts: function({commit}: {commit: Function}, payload: object): void {
    commit('setLoading', true)
    commit('setErrors', [])
    axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/getMaintenanceCosts', payload)
        .then(function(response: any) {
          commit('setBridgeMaintenanceCosts', response.data.preparedItem)
          commit('setLoading', false)
        })
        .catch(function(error: ErrorResponse) {
          commit('setLoading', false)
          commit('setErrors', error.response.data.errors)
        })
  },
  storeMaintenanceCost: function({commit}: {commit: Function}, payload: object): void {
    commit('setLoading', true)
    commit('setErrors', [])
    commit('setMsg', "")
    axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/storeMaintenanceCost', payload)
        .then(function(response: any) {
          //commit('setbridgeMaintenanceCosts', response.data.preparedItem)
          commit('setMsg', response.data.msg)
          commit('setReload', true)
          commit('setLoading', false)
        })
        .catch(function(error: ErrorResponse) {
          commit('setLoading', false)
          commit('setErrors', error.response.data.errors)
        })
  },
  updateMaintenanceCost: function({commit}: {commit: Function}, payload: object): void {
    commit('setLoading', true)
    commit('setErrors', [])
    commit('setMsg', "")
    axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/updateMaintenanceCost', payload)
        .then(function(response: any) {
          //commit('setbridgeMaintenanceCosts', response.data.preparedItem)
          commit('setMsg', response.data.msg)
          commit('setReload', true)
          commit('setLoading', false)
        })
        .catch(function(error: ErrorResponse) {
          commit('setLoading', false)
          commit('setErrors', error.response.data.errors)
        })
  },
  deleteMaintenanceCost: function({commit}: {commit: Function}, payload: object): void {
    commit('setLoading', true)
    commit('setErrors', [])
    commit('setMsg', "")
    axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/deleteMaintenanceCost', payload)
        .then(function(response: any) {
          //commit('setbridgeMaintenanceCosts', response.data.preparedItem)
          commit('setMsg', response.data.msg)
          commit('setReload', true)
          commit('setLoading', false)
        })
        .catch(function(error: ErrorResponse) {
          commit('setLoading', false)
          commit('setErrors', error.response.data.errors)
        })
  },

  //Maintenance Logs
  getMaintenanceLogs: function({commit}: {commit: Function}, payload: object): void {
    commit('setLoading', true)
    commit('setErrors', [])
    axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/getMaintenanceLogs', payload)
        .then(function(response: any) {
          commit('setBridgeMaintenanceLogs', response.data.preparedItem)
          commit('setLoading', false)
        })
        .catch(function(error: ErrorResponse) {
          commit('setLoading', false)
          commit('setErrors', error.response.data.errors)
        })
  },
  storeMaintenanceLog: function({commit}: {commit: Function}, payload: object): void {
    commit('setLoading', true)
    commit('setErrors', [])
    commit('setMsg', "")
    axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/storeMaintenanceLog', payload)
        .then(function(response: any) {
          commit('setMsg', response.data.msg)
          commit('setReload', true)
          commit('setLoading', false)
        })
        .catch(function(error: ErrorResponse) {
          commit('setLoading', false)
          commit('setErrors', error.response.data.errors)
        })
  },
  updateMaintenanceLog: function({commit}: {commit: Function}, payload: object): void {
    commit('setLoading', true)
    commit('setErrors', [])
    commit('setMsg', "")
    axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/updateMaintenanceLog', payload)
        .then(function(response: any) {
          //commit('setbridgeMaintenanceCosts', response.data.preparedItem)
          commit('setMsg', response.data.msg)
          commit('setReload', true)
          commit('setLoading', false)
        })
        .catch(function(error: ErrorResponse) {
          commit('setLoading', false)
          commit('setErrors', error.response.data.errors)
        })
  },
  deleteMaintenanceLog: function({commit}: {commit: Function}, payload: object): void {
    commit('setLoading', true)
    commit('setErrors', [])
    commit('setMsg', "")
    axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/deleteMaintenanceLog', payload)
        .then(function(response: any) {
          commit('setMsg', response.data.msg)
          commit('setReload', true)
          commit('setLoading', false)
        })
        .catch(function(error: ErrorResponse) {
          commit('setLoading', false)
          commit('setErrors', error.response.data.errors)
        })
  },


  downloadBridgePlan: function({commit}: {commit: Function}, payload: any): void {
    commit('setLoading', true)
    commit('setErrors', [])
    commit('setMsg', "")
    axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/downloadBridgePlan', payload, {
          responseType: 'arraybuffer',

        })
        .then(function(response: any) {
          //commit('setBridgePlans', response.data.preparedItem)
          const filetype = response.headers['content-type']
          const blob = new Blob([response.data], { type: filetype })
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          //const filename = response.headers['content-disposition']
          link.download = payload.originalDocName
          link.click()
          commit('setLoading', false)
        })
        .catch(function(error: ErrorResponse) {
          commit('setLoading', false)
          commit('setMsg', "Error finding file.")
          commit('setErrors', error.response.data.errors)
        })
  },

  //Bridge Plans
  getBridgePlans: function({commit}: {commit: Function}, payload: object): void {
    commit('setLoading', true)
    commit('setErrors', [])
    axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/getBridgePlans', payload)
        .then(function(response: any) {
          commit('setBridgePlans', response.data.preparedItem)
          commit('setLoading', false)
        })
        .catch(function(error: ErrorResponse) {
          commit('setLoading', false)
          commit('setErrors', error.response.data.errors)
        })
  },
  storeBridgePlan: async function({commit}: {commit: Function}, payload: any): Promise<void> {
    commit('setLoading', true)
    commit('setErrors', [])
    commit('setMsg', "")
    //File Posts must use FormData and multipart/form-data
    const data = new FormData();
    data.append("id", payload.id);
    data.append("pdf", payload.pdf);
    data.append("date", payload.date)
    data.append("notes", payload.notes)
    data.append("numOfSheets", payload.numOfSheets)
    data.append("asBuilt", payload.asBuilt)
    data.append("url", payload.url)
    data.append("bridgeId", payload.bridgeId)
    await axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/storeBridgePlan', data, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(function(response: any) {
          commit('setMsg', response.data.msg)
          commit('setReload', true)
          commit('setLoading', false)
        })
        .catch(function(error: ErrorResponse) {
          commit('setLoading', false)
          commit('setErrors', error.response.data.errors)
        })
  },
  updateBridgePlan: async function({commit}: {commit: Function}, payload: any): Promise<void> {
    commit('setLoading', true)
    commit('setErrors', [])
    commit('setMsg', "")
    //File Posts must use FormData and multipart/form-data
    const data = new FormData()
    data.append("pdf", payload.pdf)
    data.append("id", payload.id)
    data.append("date", payload.date)
    data.append("notes", payload.notes)
    data.append("numOfSheets", payload.numOfSheets)
    data.append("asBuilt", payload.asBuilt)
    data.append("url", payload.url)
    data.append("bridgeId", payload.bridgeId)
    await axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/updateBridgePlan', data, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(function(response: any) {
          commit('setMsg', response.data.msg)
          commit('setReload', true)
          commit('setLoading', false)
        })
        .catch(function(error: ErrorResponse) {
          commit('setLoading', false)
          commit('setErrors', error.response.data.errors)
        })
  },

  deleteBridgePlan: function({commit}: {commit: Function}, payload: any): void {
    commit('setLoading', true)
    commit('setErrors', [])
    commit('setMsg', "")
    axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/deleteBridgePlan', payload)
        .then(function(response: any) {
          commit('setMsg', response.data.msg)
          commit('setReload', true)
          commit('setLoading', false)
        })
        .catch(function(error: ErrorResponse) {
          commit('setLoading', false)
          commit('setErrors', error.response.data.errors)
        })
  },

  //Other Bridge Documents
  getBridgeDocuments: function({commit}: {commit: Function}, payload: object): void {
    commit('setLoading', true)
    commit('setErrors', [])
    axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/getBridgeDocuments', payload)
        .then(function(response: any) {
          commit('setBridgeDocuments', response.data.preparedItem)
          commit('setLoading', false)
        })
        .catch(function(error: ErrorResponse) {
          commit('setLoading', false)
          commit('setErrors', error.response.data.errors)
        })
  },
  storeBridgeDocument: function({commit}: {commit: Function}, payload: any): void {
    commit('setLoading', true)
    commit('setErrors', [])
    commit('setMsg', "")
    //File Posts must use FormData and multipart/form-data
    const data = new FormData();
    data.append("pdf", payload.pdf)
    data.append("id", payload.id)
    data.append("name", payload.name)
    data.append("date", payload.date)
    data.append("description", payload.description)
    data.append("url", payload.url)
    data.append("bridgeId", payload.bridgeId)
    axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/storeBridgeDocument', data, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(function(response: any) {
          commit('setMsg', response.data.msg)
          commit('setReload', true)
          commit('setLoading', false)
        })
        .catch(function(error: ErrorResponse) {
          commit('setLoading', false)
          commit('setErrors', error.response.data.errors)
        })
  },
  updateBridgeDocument: function({commit}: {commit: Function}, payload: any): void {
    commit('setLoading', true)
    commit('setErrors', [])
    commit('setMsg', "")
    //File Posts must use FormData and multipart/form-data
    const data = new FormData()
    data.append("pdf", payload.pdf)
    data.append("id", payload.id)
    data.append("name", payload.name)
    data.append("date", payload.date)
    data.append("description", payload.description)
    data.append("url", payload.url)
    data.append("bridgeId", payload.bridgeId)
    axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/updateBridgeDocument', data, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(function(response: any) {
          commit('setMsg', response.data.msg)
          commit('setReload', true)
          commit('setLoading', false)
        })
        .catch(function(error: ErrorResponse) {
          commit('setLoading', false)
          commit('setErrors', error.response.data.errors)
        })
  },
  downloadBridgeDocument: function({commit}: {commit: Function}, payload: any): void {
    commit('setLoading', true)
    commit('setMsg', "")
    commit('setErrors', [])
    axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/downloadBridgeDocument', payload, {
          responseType: 'arraybuffer',

        })
        .then(function(response: any) {
          //commit('setBridgePlans', response.data.preparedItem)
          const filetype = response.headers['content-type']
          const blob = new Blob([response.data], { type: filetype })
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          //const filename = response.headers['content-disposition']
          link.download = payload.originalDocName
          link.click()
          commit('setLoading', false)
        })
        .catch(function(error: ErrorResponse) {
          commit('setLoading', false)
          commit('setMsg', "Error finding file.")
          commit('setErrors', error.response.data.errors)
        })
  },
  deleteBridgeDocument: function({commit}: {commit: Function}, payload: any): void {
    commit('setLoading', true)
    commit('setErrors', [])
    commit('setMsg', "")
    axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/deleteBridgeDocument', payload)
        .then(function(response: any) {
          commit('setMsg', response.data.msg)
          commit('setReload', true)
          commit('setLoading', false)
        })
        .catch(function(error: ErrorResponse) {
          commit('setLoading', false)
          commit('setErrors', error.response.data.errors)
        })
  },

  //Bridge Photos
  downloadBridgePhoto: function({commit}: {commit: Function}, payload: object): void {
    commit('setLoading', true)
    commit('setErrors', [])
    commit('setMsg', "")
    axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/downloadBridgePhoto', payload, {
          responseType: 'blob'
        })
        .then(function(response: any) {
          const blob = new Blob([response.data], { type: 'application/zip' })
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'photos.zip'
          link.click()
          //commit('setBridgePhotos', response.data.preparedItem)
          commit('setLoading', false)
        })
        .catch(function(error: ErrorResponse) {
          commit('setLoading', false)
          commit('setErrors', error.response.data.errors)
        })
  },
  downloadSelectedBridgePhoto: function({commit}: {commit: Function}, payload: object): void {
    commit('setLoading', true)
    commit('setErrors', [])
    commit('setMsg', "")
    axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/downloadSelectedBridgePhoto', payload, {
          responseType: 'blob'
        })
        .then(function(response: any) {
          const blob = new Blob([response.data], { type: 'application/zip' })
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'photos.zip'
          link.click()
          //commit('setBridgePhotos', response.data.preparedItem)
          commit('setLoading', false)
        })
        .catch(function(error: ErrorResponse) {
          commit('setLoading', false)
          commit('setErrors', error.response.data.errors)
        })
  },

  getBridgePhotos: function({commit}: {commit: Function}, payload: object): void {
    commit('setLoading', true)
    commit('setErrors', [])
    axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/getBridgePhotos', payload)
        .then(function(response: any) {
          commit('setBridgePhotos', response.data.preparedItem)
          commit('setLoading', false)
        })
        .catch(function(error: ErrorResponse) {
          commit('setLoading', false)
          commit('setErrors', error.response.data.errors)
        })
  },
  getBridgeFolderPhotos: async function({commit}: {commit: Function}, payload: object): Promise<void> {
    commit('setErrors', [])
    commit('setMsg', "")
    await axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/getBridgeFolderPhotos', payload)
        .then(function(response: any) {
          commit('setBridgeFolderPhotos', response.data.preparedItem)
        })
        .catch(function(error: ErrorResponse) {
          commit('setErrors', error.response.data.errors)
        })
  },
  storeBridgePhoto: function({commit}: {commit: Function}, payload: any): void {
    commit('setLoading', true)
    commit('setErrors', [])
    commit('setMsg', "")
    const data = new FormData();
    if(payload.images) {
      for( let i = 0; i < payload.images.length; i++ ){
        const image = payload.images[i];
        data.append('images[' + i + ']', image);
      }
    }
    data.append("id", payload.id)
    data.append("notes", payload.notes)
    data.append("date", payload.date)
    data.append("description", payload.description)
    data.append("bridgeId", payload.bridgeId)
    axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/storeBridgePhoto', data, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(function(response: any) {
          commit('setMsg', response.data.msg)
          commit('setReload', true)
          commit('setLoading', false)
        })
        .catch(function(error: ErrorResponse) {
          commit('setLoading', false)
          commit('setErrors', error.response.data.errors)
        })
  },
  addBridgePhoto: function({commit}: {commit: Function}, payload: any): void {
    commit('setLoading', true)
    commit('setErrors', [])
    commit('setMsg', "")
    const data = new FormData();
    if(payload.images) {
      for( let i = 0; i < payload.images.length; i++ ){
        const image = payload.images[i];
        data.append('images[' + i + ']', image);
      }
    }
    data.append("bridgePhotoFolderId", payload.bridgePhotoFolderId)
    axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/addBridgePhoto', data, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(function(response: any) {
          commit('setMsg', response.data.msg)
          commit('setReload', true)
          commit('setLoading', false)
        })
        .catch(function(error: ErrorResponse) {
          commit('setLoading', false)
          commit('setErrors', error.response.data.errors)
        })
  },

  updateBridgePhoto: function({commit}: {commit: Function}, payload: any): void {
    commit('setLoading', true)
    commit('setErrors', [])
    commit('setMsg', "")
    axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/updateBridgePhoto', payload)
        .then(function(response: any) {
          commit('setMsg', response.data.msg)
          commit('setReload', true)
          commit('setLoading', false)
        })
        .catch(function(error: ErrorResponse) {
          commit('setLoading', false)
          commit('setErrors', error.response.data.errors)
        })
  },
  deleteBridgePhoto: function({commit}: {commit: Function}, payload: any): void {
    commit('setLoading', true)
    commit('setErrors', [])
    commit('setMsg', "")
    axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/deleteBridgePhoto', payload)
        .then(function(response: any) {
          commit('setMsg', response.data.msg)
          commit('setReload', true)
          commit('setLoading', false)
        })
        .catch(function(error: ErrorResponse) {
          commit('setLoading', false)
          commit('setErrors', error.response.data.errors)
        })
  },
  deleteBridgePhotos: function({commit}: {commit: Function}, payload: any): void {
    commit('setLoading', true)
    commit('setErrors', [])
    commit('setMsg', "")
    axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/deleteBridgePhotos', payload)
        .then(function(response: any) {
          commit('setMsg', response.data.msg)
          commit('setReload', true)
          commit('setLoading', false)
        })
        .catch(function(error: ErrorResponse) {
          commit('setLoading', false)
          commit('setErrors', error.response.data.errors)
        })
  },

  getBridgeInspectionReports: function({commit}: {commit: Function}, payload: object): void {
    commit('setLoading', true)
    commit('setErrors', [])
    axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/getBridgeInspectionReports', payload)
        .then(function(response: any) {
          commit('setBridgeInspectionReports', response.data.preparedItem)
          commit('setLoading', false)
        })
        .catch(function(error: ErrorResponse) {
          commit('setLoading', false)
          commit('setErrors', error.response.data.errors)
        })
  },
  saveBridgeInspectionGeneral: function({commit}: {commit: Function}, payload: object): void {
    commit('setLoading', true)
    commit('setErrors', [])
    commit('setMsg', "")
    axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/updateBridgeGeneralInspection', payload)
        .then(function(response: any) {
          commit('setMsg', response.data.msg)
          commit('setReload', true)
          commit('setLoading', false)
        })
        .catch(function(error: ErrorResponse) {
          commit('setLoading', false)
          commit('setErrors', error.response.data.errors)
        })
  },

  storeBridgeInspectionReport: function({commit}: {commit: Function}, payload: any): void {
        commit('setLoading', true)
        commit('setErrors', [])
        commit('setMsg', "")
        //File Posts must use FormData and multipart/form-data
        const data = new FormData();
        data.append("id", payload.id);
        data.append("bridgeId", payload.bridgeId);
        data.append("date", payload.date);
        data.append("channel", payload.channel);
        data.append("culvert", payload.culvert);
        data.append("deck", payload.deck);
        data.append("sufficiencyRating", payload.sufficiencyRating);
        data.append("recommendedRepairs", payload.recommendedRepairs);
        payload.tags.forEach(element => {
          data.append('tags[]', element);
        });
        data.append("scourCritical", payload.scourCritical);
        data.append("subStructure", payload.subStructure);
        data.append("paintCondition", payload.paintCondition);
        data.append("superStructure", payload.superStructure);
        data.append("user", payload.user);
        data.append("inspectedBy", payload.inspectedBy);
        data.append("pdf", payload.pdf);
        data.append("url", payload.url);
        axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/storeBridgeInspectionReport', data, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(function(response: any) {
          commit('setMsg', response.data.msg)
          commit('setReload', true)
          commit('setLoading', false)
        })
        .catch(function(error: ErrorResponse) {
          commit('setLoading', false)
          commit('setErrors', error.response.data.errors)
        })
  },

  updateBridgeInspectionReport: function({commit}: {commit: Function}, payload: any): void {
        commit('setLoading', true)
        commit('setErrors', [])
        commit('setMsg', "")
        //File Posts must use FormData and multipart/form-data
        const data = new FormData();
        data.append("id", payload.id);
        data.append("bridgeId", payload.bridgeId);
        data.append("date", payload.date);
        data.append("channel", payload.channel);
        data.append("culvert", payload.culvert);
        data.append("deck", payload.deck);
        data.append("sufficiencyRating", payload.sufficiencyRating);
        data.append("recommendedRepairs", payload.recommendedRepairs);
        payload.tags.forEach(element => {
          data.append('tags[]', element);
        });
        data.append("scourCritical", payload.scourCritical);
        data.append("subStructure", payload.subStructure);
        data.append("superStructure", payload.superStructure);
        data.append("user", payload.user);
        data.append("inspectedBy", payload.inspectedBy);
        data.append("paintCondition", payload.paintCondition);
        data.append("pdf", payload.pdf);
        data.append("url", payload.url);
        axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/updateBridgeInspectionReport', data, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(function(response: any) {
          commit('setMsg', response.data.msg)
          commit('setReload', true)
          commit('setLoading', false)
        })
        .catch(function(error: ErrorResponse) {
          commit('setLoading', false)
          commit('setErrors', error.response.data.errors)
        })
  },

  deleteBridgeInspectionReport: function({commit}: {commit: Function}, payload: any): void {
    commit('setLoading', true)
    commit('setErrors', [])
    commit('setMsg', "")
    axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/deleteBridgeInspectionReport', payload)
        .then(function(response: any) {
          commit('setMsg', response.data.msg)
          commit('setReload', true)
          commit('setLoading', false)
        })
        .catch(function(error: ErrorResponse) {
          commit('setLoading', false)
          commit('setErrors', error.response.data.errors)
        })
  },

  downloadBridgeInspectionReport: function({commit}: {commit: Function}, payload: any): void {
    commit('setLoading', true)
    commit('setMsg', "")
    commit('setErrors', [])
    axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/downloadBridgeInspectionReport', payload, {
          responseType: 'arraybuffer',

        })
        .then(function(response: any) {
          //commit('setBridgePlans', response.data.preparedItem)
          const filetype = response.headers['content-type']
          const blob = new Blob([response.data], { type: filetype })
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          //const filename = response.headers['content-disposition']
          link.download = payload.originalDocName
          link.click()
          commit('setLoading', false)
        })
        .catch(function(error: ErrorResponse) {
          commit('setLoading', false)
          commit('setMsg', "Error finding file.")
          commit('setErrors', error.response.data.errors)
        })
  },
  openBridgeDocumentPDF: function({commit}: {commit: Function}, payload: any): void {
    commit('setLoading', true)
    axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/readBridgeDocumentPDF', payload, {
          responseType: 'arraybuffer',
        })
        .then(function(response: any) {
            commit('setLoading', false)
            const blob = new Blob([response.data], { type: 'application/pdf' })
            const fileURL = URL.createObjectURL(blob);
            window.open(fileURL)
        })
        .catch(function(error: ErrorResponse) {
          commit('setLoading', false)
          commit('setMsg', "Error file does not exist.")
        })
  },
  openBridgePlanPDF: function({commit}: {commit: Function}, payload: any): void {
    commit('setLoading', true)
    axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/readBridgePlanPDF', payload, {
          responseType: 'arraybuffer',
        })
        .then(function(response: any) {
            commit('setLoading', false)
            const blob = new Blob([response.data], { type: 'application/pdf' })
            const fileURL = URL.createObjectURL(blob);
            window.open(fileURL)
        })
        .catch(function(error: ErrorResponse) {
          commit('setLoading', false)
          commit('setMsg', "Error file does not exist.")
        })
  },
  openBridgeInspectionReportPDF: function({commit}: {commit: Function}, payload: any): void {
    commit('setLoading', true)
    axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/readBridgeInspectionReportPDF', payload, {
          responseType: 'arraybuffer',
        })
        .then(function(response: any) {
            commit('setLoading', false)
            const blob = new Blob([response.data], { type: 'application/pdf' })
            const fileURL = URL.createObjectURL(blob);
            window.open(fileURL)
        })
        .catch(function(error: ErrorResponse) {
          commit('setLoading', false)
          commit('setMsg', "Error file does not exist.")
        })
  },

  getBridgeLogs: async function({commit}: {commit: Function}, payload: object): Promise<void> {
    commit('setLogs', [])
    commit('setErrors', [])
    commit('setMsg', "")
    await axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/getBridgeLogs', payload)
        .then(function(response: any) {
          commit('setMsg', response.data.msg)
          commit('setLogs', response.data.logs)
        })
        .catch(function(error: ErrorResponse) {
          commit('setErrors', error.response.data.errors)
        })
  },
  getBridgeSpecialItems: function({commit}: {commit: Function}, payload: object): void {
    commit('setLoading', true)
    commit('setErrors', [])
    axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/getBridgeSpecialItems', payload)
        .then(function(response: any) {
          commit('setBridgeSpecialItems', response.data.special_items)
          commit('setLoading', false)
        })
        .catch(function(error: ErrorResponse) {
          commit('setLoading', false)
          commit('setErrors', error.response.data.errors)
        })
  },

  updateBridgeSpecialItem: function({commit}: {commit: Function}, payload: any): void {
    commit('setLoading', true)
    commit('setErrors', [])
    commit('setMsg', "")
    axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/updateBridgeSpecialItem', payload)
        .then(function(response: any) {
          commit('setMsg', response.data.msg)
          commit('setReload', true)
          commit('setLoading', false)
        })
        .catch(function(error: ErrorResponse) {
          commit('setLoading', false)
          commit('setErrors', error.response.data.errors)
        })
  },
  deleteBridgeSpecialItem: function({commit}: {commit: Function}, payload: any): void {
    commit('setLoading', true)
    commit('setErrors', [])
    commit('setMsg', "")
    axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/deleteBridgeSpecialItem', payload)
        .then(function(response: any) {
          commit('setMsg', response.data.msg)
          commit('setReload', true)
          commit('setLoading', false)
        })
        .catch(function(error: ErrorResponse) {
          commit('setLoading', false)
          commit('setErrors', error.response.data.errors)
        })
  },
  getBridgePermitRatings: function({commit}: {commit: Function}, payload: object): void {
    commit('setLoading', true)
    commit('setErrors', [])
    axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/getBridgePermitRatings', payload)
        .then(function(response: any) {
          commit('setBridgePermitRatings', response.data.permit_ratings)
          commit('setLoading', false)
        })
        .catch(function(error: ErrorResponse) {
          commit('setLoading', false)
          commit('setErrors', error.response.data.errors)
        })
  },
  storeBridgePermitRating: function({commit}: {commit: Function}, payload: object): void {
    commit('setLoading', true)
    commit('setErrors', [])
    commit('setMsg', "")
    axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/storeBridgePermitRating', payload)
        .then(function(response: any) {
          commit('setMsg', response.data.msg)
          commit('setReload', true)
          commit('setLoading', false)
        })
        .catch(function(error: ErrorResponse) {
          commit('setLoading', false)
          commit('setErrors', error.response.data.errors)
        })
  },
  updateBridgePermitRating: function({commit}: {commit: Function}, payload: object): void {
    commit('setLoading', true)
    commit('setErrors', [])
    commit('setMsg', "")
    axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/updateBridgePermitRating', payload)
        .then(function(response: any) {
          commit('setMsg', response.data.msg)
          commit('setReload', true)
          commit('setLoading', false)
        })
        .catch(function(error: ErrorResponse) {
          commit('setLoading', false)
          commit('setErrors', error.response.data.errors)
        })
  },
  deleteBridgePermitRating: function({commit}: {commit: Function}, payload: any): void {
    commit('setLoading', true)
    commit('setErrors', [])
    commit('setMsg', "")
    axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/deleteBridgePermitRating', payload)
        .then(function(response: any) {
          commit('setMsg', response.data.msg)
          commit('setReload', true)
          commit('setLoading', false)
        })
        .catch(function(error: ErrorResponse) {
          commit('setLoading', false)
          commit('setErrors', error.response.data.errors)
        })
  },
  downloadBridgeList: function({commit}: {commit: Function}): void {
    commit('setLoading', true)
    commit('setErrors', [])
    commit('setMsg', "")
    axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/downloadBridgeList', {}, { responseType: 'arraybuffer' })
      .then(function(response: any) {
        commit('setMsg', response.data.msg)
        commit('setLoading', false)
        fileDownload(response.data, 'bridge_list.xlsx')
      })
      .catch(function(error: ErrorResponse) {
        console.log(error)
        commit('setLoading', false)
        commit('setErrors', error.response.data.errors)
      })
  },
  downloadBridgeEvaluation: function({commit}: {commit: Function}): void {
    commit('setLoading', true)
    commit('setErrors', [])
    commit('setMsg', "")
    axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/downloadRoadwayEvaluation', {}, { responseType: 'arraybuffer' })
      .then(function(response: any) {
        commit('setMsg', response.data.msg)
        commit('setLoading', false)
        fileDownload(response.data, 'roadway_evaluation.xlsx')
      })
      .catch(function(error: ErrorResponse) {
        console.log(error)
        commit('setLoading', false)
        commit('setErrors', error.response.data.errors)
      })
  },
  downloadBridgeMaintenance: function({commit}: {commit: Function}): void {
    commit('setLoading', true)
    commit('setErrors', [])
    commit('setMsg', "")
    axios.post(process.env.VUE_APP_TRAFFIC_API+'api/bridge/downloadBridgeMaintenance', {}, { responseType: 'arraybuffer' })
      .then(function(response: any) {
        commit('setMsg', response.data.msg)
        commit('setLoading', false)
        fileDownload(response.data, 'roadway_maintenance.xlsx')
      })
      .catch(function(error: ErrorResponse) {
        console.log(error)
        commit('setLoading', false)
        commit('setErrors', error.response.data.errors)
      })
  }
}

const mutations = {
  setLogs: function(state: State, payload: []): void { state.logs = payload },
  setLoading: function(state: State, payload: boolean): void { state.loading = payload },
  setReload: function(state: State, payload: boolean): void { state.reload = payload },
  setItem: function(state: State, payload: []): void { state.item = payload },
  setItems: function(state: State, payload: []): void { state.items = payload },
  setPreparedItem: function(state: State, payload: []): void { state.preparedItem = payload },
  setBridgeMaintenanceCosts: function(state: State, payload: []): void { state.bridgeMaintenanceCosts = payload },
  setBridgeMaintenanceLogs: function(state: State, payload: []): void { state.bridgeMaintenanceLogs = payload },
  setBridgePlans: function(state: State, payload: []): void { state.bridgePlans = payload },
  setBridgeDocuments: function(state: State, payload: []): void { state.bridgeDocuments = payload },
  setBridgePhotos: function(state: State, payload: []): void { state.bridgePhotos = payload },
  setBridgeFolderPhotos: function(state: State, payload: []): void { state.bridgeFolderPhotos = payload },
  setBridgeInspectionReports: function(state: State, payload: []): void { state.bridgeInspectionReports = payload },
  setBridgePermitRatings: function(state: State, payload: []): void { state.bridgePermitRatings = payload },
  setBridgeSpecialItems: function(state: State, payload: []): void { state.bridgeSpecialItems = payload },
  setErrors: function(state: State, payload: []): void { state.errors = payload },
  setMsg: function(state: State, payload: string): void { state.msg = payload },

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
